export default __webpack_public_path__ + "static/media/Swat_pfp.b506e607.png";